/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import clsx from 'clsx'
import DateTimePicker from 'react-datetime-picker'
import { CustomSelect } from './select-react/CustomSelect'
import { getModels as getProduct } from '../../../modules/product-management/core/_requests'
import { ModelQueryResponse as ProductQueryResponse } from '../../../modules/product-management/core/_models'
import { getModels as getProductCategory } from '../../../modules/productcategory-management/core/_requests'
import { ModelQueryResponse as ProductCategoryQueryResponse } from '../../../modules/productcategory-management/core/_models'
import { VisaDashboardQueryResponce } from '../core/_models'
import { getvisadashborddata } from '../core/_requests'
import { isNotEmpty } from "../../../../_metronic/helpers";
import { isEmptyArray } from "formik";

type Props = {
  className?: string
  onVisaFilterSubmit: (filters: any) => void;
  // model?: DashboardCountModel
}
const VisaFilterForm = ({ className, onVisaFilterSubmit }: Props) => {

  const [selectedProducts, setSelectedProducts] = useState<unknown[]>([]);
  const [selectedCategoryProducts, setSelectedCategoryProducts] = useState<unknown[]>([]);
  const [selectedFileStage, setSelectedFileStage] = useState<unknown[]>([]);
  const [selectedFileStatus, setSelectedFileStatus] = useState<unknown[]>([]);
  const [selectedNbPartner, setSelectedNbPartner] = useState<unknown[]>([]);
  const [selectedSalesExe, setSelectedSalesExe] = useState<unknown[]>([]);
  const [selectedFileExe, setSelectedFileExe] = useState<unknown[]>([]);
  const [selectedVisaAssignBy, setSelectedVisaAssignBy] = useState<unknown[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<unknown[]>([]);
  const [selectedStartDate, setSelectedStartDate] = useState<Date | undefined>();
  const [selectedEndDate, setSelectedEndDate] = useState<Date | undefined>();
  const [selectedVendor, setSelectedVendor] = useState<unknown[]>([]);
  const [selectedFollowup, setSelectedFollowup] = useState<unknown[]>([]);
  const [selectedAppliedStartDate, setSelectedAppliedStartDate] = useState<Date | undefined>();
  const [selectedAppliedEndDate, setSelectedAppliedEndDate] = useState<Date | undefined>();

  // const [selectedMou, setSelectedMou] = useState<unknown[]>([]);
  // const [selectedMouProducts, setSelectedMouProducts] = useState<unknown[]>([]);


  const [visadashboard, setVisaDashboard] = useState<VisaDashboardQueryResponce>() as any;
  const [visadashboardLoading, setVisaDashboardLoading] = useState(true);

  const searchParams = new URLSearchParams(window.location.search);
  const FilterValue = searchParams.toString();
  const keyValuePairs = FilterValue.split("&");
  const params = {} as any;
  keyValuePairs.forEach((pair) => {
    const [key, value] = pair.split("=");
    if (key === 'visa_followup_option' || (key === 'visa_NbPartner_Id' && value === 'nb')) {
      params[key] = value;
    } else {
      params[key] = parseInt(value);
    }

  });
  // const FilterKey = FilterValue.split('=')[0]
  // const FilterId = FilterValue.split('=')[1];

  console.log('FilterKey', params)
  // console.log('FilterId', params['inq_Exe_Id'])

  useEffect(() => {
    getvisadashborddata('').then((result) => {
      setVisaDashboard(result);
      setVisaDashboardLoading(false);
    });
  }, []);

  console.log("visa_data", visadashboard?.data?.['nbpartner']);
  const [product, setProduct] = useState<ProductQueryResponse>();
  const [productLoading, setProductLoading] = useState(true);
  useEffect(() => {
    getProduct('').then((result) => {
      setProduct(result);
      setProductLoading(false);
    });
  }, []);

  // const [productMou, setMouProduct] = useState<ProductQueryResponse>();
  // const [productMouLoading, setMouProductLoading] = useState(true);

  // useEffect(() => {
  //     getProduct('has_mou=yes').then((result) => {
  //       setMouProduct(result);
  //       setMouProductLoading(false);

  //       const productIds = result?.data?.map((product) => product.id);
  //       setSelectedMouProducts(productIds || []);

  //     });
  // }, [selectedMou]);

  // console.log('product', selectedMouProducts)

  const [productcategory, setProductcategory] = useState<ProductCategoryQueryResponse>();
  const [productcategoryLoading, setProductcategoryLoading] = useState(true);
  useEffect(() => {
    if (params.hasOwnProperty('product_cate_Id')) {
      getProductCategory('NameFilterProductCateId').then((result) => {
        setProductcategory(result);
        setProductcategoryLoading(false);
      });
    } else {
      if (selectedProducts.length > 0) {
        getProductCategory('product_id_In=' + selectedProducts).then((result) => {
          setProductcategory(result);
          setProductcategoryLoading(false);
        });
      }
      //  else if (selectedMouProducts.length > 0){
      //   getProductCategory('product_id_In=' + selectedMouProducts).then((result) => {
      //     setProductcategory(result);
      //     setProductcategoryLoading(false);
      //   });
      // }
      else {
        setSelectedCategoryProducts([]);
        setProductcategory(undefined);
        setProductcategoryLoading(false);
      }
    }
  }, [selectedProducts]);
  console.log('visa_NbPartner_Id', params)
  useEffect(() => {
    if (params.hasOwnProperty('product_Id') && selectedProducts.length === 0) {
      setSelectedProducts([params['product_Id']]);
    }
    if (params.hasOwnProperty('product_cate_Id') && selectedCategoryProducts.length === 0) {
      setSelectedCategoryProducts([params['product_cate_Id']]);
    }
    if (params.hasOwnProperty('visa_FileStage_Id') && selectedFileStage.length === 0) {
      setSelectedFileStage([params['visa_FileStage_Id']]);
    }
    if (params.hasOwnProperty('visa_FileStatus_Id') && selectedFileStatus.length === 0) {
      setSelectedFileStatus([params['visa_FileStatus_Id']]);

    }
    if (params.hasOwnProperty('visa_NbPartner_Id') && selectedNbPartner.length === 0) {
      if (String(params['visa_NbPartner_Id']) === 'nb') {
        setSelectedNbPartner(['nb']);
      } else {
        setSelectedNbPartner([params['visa_NbPartner_Id']]);
      }
    }
    if (params.hasOwnProperty('visa_SalesExe_Id') && selectedSalesExe.length === 0) {
      setSelectedSalesExe([params['visa_SalesExe_Id']]);

    }
    if (params.hasOwnProperty('visa_FileExe_Id') && selectedFileExe.length === 0) {
      setSelectedFileExe([params['visa_FileExe_Id']]);
    }
    if (params.hasOwnProperty('visa_VisaAssignBy_Id') && selectedVisaAssignBy.length === 0) {
      setSelectedVisaAssignBy([params['visa_VisaAssignBy_Id']]);
    }
    if (params.hasOwnProperty('visa_Country_Id') && selectedCountry.length === 0) {
      setSelectedCountry([params['visa_Country_Id']]);
    }
    if (params.hasOwnProperty('vendor_Id') && selectedVendor.length === 0) {
      setSelectedVendor([params['vendor_Id']]);
    }
    if (params.hasOwnProperty('visa_followup_option') && selectedFollowup.length === 0) {
      setSelectedFollowup(params['visa_followup_option']);
    }
    if (selectedProducts.length > 0 || selectedCategoryProducts.length > 0 || selectedFileStage.length > 0 || selectedFileStatus.length > 0 || selectedNbPartner.length > 0 || selectedSalesExe.length > 0 || selectedFileExe.length > 0 || selectedCountry.length > 0 || selectedVisaAssignBy.length > 0 || selectedVendor.length > 0 || selectedFollowup.length > 0) {
      handleFormSubmit();
    }
  }, [visadashboard]);

  console.log('selectedFollowup', selectedFollowup.length)
  const resetForm = () => {
    setSelectedProducts([]);
    setSelectedCategoryProducts([]);
    setSelectedFileStage([]);
    setSelectedFileStatus([]);
    setSelectedNbPartner([]);
    setSelectedSalesExe([]);
    setSelectedFileExe([]);
    setSelectedVisaAssignBy([]);
    setSelectedCountry([]);
    setSelectedVendor([]);
    setSelectedFollowup([]);
    // setSelectedMou([]);
    // setSelectedMouProducts([]);
    setSelectedStartDate(undefined);
    setSelectedAppliedStartDate(undefined);
    setSelectedAppliedEndDate(undefined);
    setSelectedEndDate(undefined);
  };
  const handleFormReset = () => {
    resetForm();
    const Reset = {
      product_Id: '',
      product_cate_Id: '',
      visa_FileStage_Id: '',
      visa_FileStatus_Id: '',
      visa_NbPartner_Id: '',
      visa_SalesExe_Id: '',
      visa_FileExe_Id: '',
      visa_VisaAssignBy_Id: '',
      visa_Country_Id: '',
      vendor_Id: '',
      start_date: '',
      end_date: '',
      visa_followup_option: '',
      applied_date: ''
      // selected_mou: '',
      // selected_MouProducts:''

    };
    onVisaFilterSubmit(Reset);
  };
  const handleFormSubmit = () => {
    if (selectedEndDate || selectedStartDate || selectedAppliedStartDate || selectedAppliedEndDate || selectedProducts.length > 0 || selectedCategoryProducts.length > 0 || selectedFileStage.length > 0 || selectedFileStatus.length > 0 || selectedNbPartner.length > 0 || selectedSalesExe.length > 0 || selectedFileExe.length > 0 || selectedCountry.length > 0 || selectedVisaAssignBy.length > 0 || selectedVendor.length > 0 || selectedFollowup.length > 0) {
      const filters = {
        product_Id: selectedProducts ? selectedProducts : [],
        product_cate_Id: selectedCategoryProducts ? selectedCategoryProducts : '',
        visa_FileStage_Id: selectedFileStage ? selectedFileStage : '',
        visa_FileStatus_Id: selectedFileStatus ? selectedFileStatus : '',
        visa_NbPartner_Id: selectedNbPartner ? selectedNbPartner : '',
        visa_SalesExe_Id: selectedSalesExe ? selectedSalesExe : '',
        visa_FileExe_Id: selectedFileExe ? selectedFileExe : '',
        visa_VisaAssignBy_Id: selectedVisaAssignBy ? selectedVisaAssignBy : '',
        visa_Country_Id: selectedCountry ? selectedCountry : '',
        vendor_Id: selectedVendor ? selectedVendor : '',
        start_date: selectedStartDate ? selectedStartDate : '',
        end_date: selectedEndDate ? selectedEndDate : '',
        visa_followup_option: selectedFollowup ? selectedFollowup : '',
        applied_start_date: selectedAppliedStartDate ? selectedAppliedStartDate : '',
        applied_end_date: selectedAppliedEndDate ? selectedAppliedEndDate : ''
        // selected_mou: selectedMou ? selectedMou : '',
        // selected_MouProducts: selectedMouProducts ? selectedMouProducts : '',



        // ... add other selected filter values here
      };
      onVisaFilterSubmit(filters);
    }
    else {
      const filters = {
        // ... add other selected filter values here
      };
      onVisaFilterSubmit(filters);
    }

  };

  const followupOption = [
    { label: 'YES', value: 'yes' },
    { label: 'NO', value: 'no' },
    { label: 'ACTIVE', value: 'active' },
    { label: 'DEACTIVE', value: 'deactive' },
    { label: `PAST-ACTIVE FOLLOWUP`, value: 'past_active' },
    { label: `TODAY'S FOLLOWUP`, value: 't_followup' },
    { label: `TODAY'S TASK`, value: 't_task' },

  ];

  const MouOption = [
    { label: 'YES', value: 'yes' },
    { label: 'NO', value: 'no' },
  ];


  return (
    visadashboard?.data && (
      <div className={clsx('card', className)}>
        <div className='card-body d-flex align-items-center justify-content-between flex-wrap'>
          {/* <div className='separator border-gray-200'></div> */}
          <div className='row row-cols-4'>
            {
              visadashboard?.data && (
                <div className='col'>
                  <div className='mb-3'>
                    {/* <label className='form-label fs-7 fw-semibold'>Is Active:</label> */}
                    <DateTimePicker
                      className={clsx(
                        'form-control form-control-solid mb-3 mb-lg-0',
                      )}
                      format={'dd/MM/yyyy'}
                      onChange={(e) => setSelectedStartDate(e)}
                      value={selectedStartDate}
                      dayPlaceholder={'Start '}
                      monthPlaceholder=" Date"
                    />
                  </div>
                </div>
              )
            }
            {
              visadashboard?.data && (
                <div className='col'>
                  <div className='mb-3'>
                    {/* <label className='form-label fs-7 fw-semibold'>Is Active:</label> */}
                    <DateTimePicker
                      className={clsx(
                        'form-control form-control-solid mb-3 mb-lg-0',
                      )}
                      format={'dd/MM/yyyy'}
                      onChange={(e) => setSelectedEndDate(e)}
                      value={selectedEndDate}
                      dayPlaceholder={'End '}
                      monthPlaceholder="Date"
                    />
                  </div>
                </div>
              )
            }

            {
              visadashboard?.data && (
                <div className='col'>
                  <div className='mb-3'>
                    {/* <label className='form-label fs-7 fw-semibold'>Is Active:</label> */}
                    <DateTimePicker
                      className={clsx(
                        'form-control form-control-solid mb-3 mb-lg-0',
                      )}
                      format={'dd/MM/yyyy'}
                      onChange={(e) => setSelectedAppliedStartDate(e)}
                      value={selectedAppliedStartDate}
                      dayPlaceholder={'applied '}
                      monthPlaceholder="Start"
                      yearPlaceholder="Date"
                    />
                  </div>
                </div>
              )
            }

            {
              visadashboard?.data && (
                <div className='col'>
                  <div className='mb-3'>
                    {/* <label className='form-label fs-7 fw-semibold'>Is Active:</label> */}
                    <DateTimePicker
                      className={clsx(
                        'form-control form-control-solid mb-3 mb-lg-0',
                      )}
                      format={'dd/MM/yyyy'}
                      onChange={(e) => setSelectedAppliedEndDate(e)}
                      value={selectedAppliedEndDate}
                      dayPlaceholder={'applied '}
                      monthPlaceholder="End"
                      yearPlaceholder="Date"
                    />
                  </div>
                </div>
              )
            }

            {
              visadashboard?.data?.['visaproducts'] && (
                <div className='col'>
                  <div className='mb-3'>
                    <CustomSelect
                      className={'form-select-solid fw-bold'}
                      // options={
                      //   selectedMou.length > 0 ? (
                      //     productMou?.data?.map((object: any, index: any) => {
                      //       return {
                      //         'label': object.product_name, 'value': object.id
                      //       }
                      //     })
                      //   ) : (
                      //     product?.data?.map((object: any, index: any) => {
                      //       return {
                      //         'label': object.product_name, 'value': object.id
                      //       }
                      //     })  
                      //   )
                      // }
                      options={product?.data?.map((object: any, index: any) => {
                        return {
                          'label': object.product_name, 'value': object.id
                        }
                      })}
                      value={selectedProducts}
                      onChange={(value: any) => {
                        if (value) {
                          setSelectedProducts(Array.prototype.map.call(value, function (v) { return v.value; }));
                          // setProductcategoryLoading(true)
                        }

                      }}
                      isMulti={product?.data?.map((object: any, index: any) => {
                        return {
                          'label': object.product_name, 'value': object.id
                        }
                      })}
                      // isLoading={selectedMou.length > 0 ? productMouLoading :productLoading}
                      isLoading={productLoading}
                      placeholder={"Select Inquiry Products"}
                    />
                  </div>
                </div>
              )
            }

            {
              visadashboard?.data?.['visacategoryproducts'] && (
                <div className='col'>
                  <div className='mb-3'>
                    <CustomSelect
                      className={'form-select-solid fw-bold'}
                      options={productcategory?.data?.map((object: any, index: any) => {
                        return {
                          'label': object.product_category_name, 'value': object.id
                        }
                      })}
                      value={selectedCategoryProducts}
                      onChange={(value: any) => {
                        if (value) {
                          setSelectedCategoryProducts(Array.prototype.map.call(value, function (v) { return v.value; }));
                        }

                      }}
                      isMulti={productcategory?.data?.map((object: any, index: any) => {
                        return {
                          'label': object.product_category_name, 'value': object.id
                        }
                      })}
                      isLoading={productcategoryLoading}
                      placeholder={"Select Product Category"}
                    />
                  </div>
                </div>
              )
            }

            {
              visadashboard?.data?.['filestage'] && (
                <div className='col'>
                  <div className='mb-3'>
                    <CustomSelect
                      className={'form-select-solid fw-bold'}
                      options={visadashboard?.data?.filestage.map((object: any, index: any) => {
                        return {
                          'label': object.name, 'value': object.id
                        }
                      })}
                      value={selectedFileStage}
                      onChange={(value: any) => {
                        if (value) {
                          setSelectedFileStage(Array.prototype.map.call(value, function (v) { return v.value; }));
                        }

                      }}
                      isMulti={visadashboard?.data?.filestage.map((object: any, index: any) => {
                        return {
                          'label': object.name, 'value': object.id
                        }
                      })}
                      isLoading={visadashboardLoading}
                      placeholder={"Select File Stage"}
                    />
                  </div>
                </div>
              )
            }

            {
              visadashboard?.data?.['filestatus'] && (
                <div className='col'>
                  <div className='mb-3'>
                    <CustomSelect
                      className={'form-select-solid fw-bold'}
                      options={visadashboard?.data?.filestatus.map((object: any, index: any) => {
                        return {
                          'label': object.name, 'value': object.id
                        }
                      })}
                      value={selectedFileStatus}
                      onChange={(value: any) => {
                        if (value) {
                          setSelectedFileStatus(Array.prototype.map.call(value, function (v) { return v.value; }));
                        }

                      }}
                      isMulti={visadashboard?.data?.filestatus.map((object: any, index: any) => {
                        return {
                          'label': object.name, 'value': object.id
                        }
                      })}
                      isLoading={visadashboardLoading}
                      placeholder={"Select File Status"}
                    />
                  </div>
                </div>
              )
            }

            {
              visadashboard?.data?.['nbpartner'] && (
                <div className='col'>
                  <div className='mb-3'>
                    <CustomSelect
                      className={'form-select-solid fw-bold'}
                      //   options={
                      //     visadashboard?.data?.nbpartner.map((object: any, index: any) => {
                      //     return {
                      //       'label': object.name, 'value': object.id
                      //     }
                      //   })
                      // }
                      options={[
                        { label: 'NB', value: 'nb' },
                        ...visadashboard?.data?.nbpartner.map((object: any) => ({
                          label: object.name,
                          value: object.id
                        }))
                      ]}
                      value={selectedNbPartner}
                      onChange={(value: any) => {
                        if (value) {
                          setSelectedNbPartner(Array.prototype.map.call(value, function (v) { return v.value; }));
                        }

                      }}
                      isMulti={visadashboard?.data?.nbpartner.map((object: any, index: any) => {
                        return {
                          'label': object.name, 'value': object.id
                        }
                      })}
                      isLoading={visadashboardLoading}
                      placeholder={"Select Nb/Partner"}
                    />
                  </div>
                </div>
              )
            }

            {
              visadashboard?.data?.['salesexecutive'] && (
                <div className='col'>
                  <div className='mb-3'>
                    <CustomSelect
                      className={'form-select-solid fw-bold'}
                      options={visadashboard?.data?.salesexecutive.map((object: any, index: any) => {
                        return {
                          'label': object.name, 'value': object.id
                        }
                      })}
                      value={selectedSalesExe}
                      onChange={(value: any) => {
                        if (value) {
                          setSelectedSalesExe(Array.prototype.map.call(value, function (v) { return v.value; }));
                        }

                      }}
                      isMulti={visadashboard?.data?.salesexecutive.map((object: any, index: any) => {
                        return {
                          'label': object.name, 'value': object.id
                        }
                      })}
                      isLoading={visadashboardLoading}
                      placeholder={"Select Sales Executive"}
                    />
                  </div>
                </div>
              )
            }

            {
              visadashboard?.data?.['fileexecutive'] && (
                <div className='col'>
                  <div className='mb-3'>
                    <CustomSelect
                      className={'form-select-solid fw-bold'}
                      options={visadashboard?.data?.fileexecutive.map((object: any, index: any) => {
                        return {
                          'label': object.name, 'value': object.id
                        }
                      })}
                      value={selectedFileExe}
                      onChange={(value: any) => {
                        if (value) {
                          setSelectedFileExe(Array.prototype.map.call(value, function (v) { return v.value; }));
                        }

                      }}
                      isMulti={visadashboard?.data?.fileexecutive.map((object: any, index: any) => {
                        return {
                          'label': object.name, 'value': object.id
                        }
                      })}
                      isLoading={visadashboardLoading}
                      placeholder={"Select File Executive"}
                    />
                  </div>
                </div>
              )
            }

            {
              visadashboard?.data?.['visaassignby'] && (
                <div className='col'>
                  <div className='mb-3'>
                    <CustomSelect
                      className={'form-select-solid fw-bold'}
                      options={visadashboard?.data?.visaassignby.map((object: any, index: any) => {
                        return {
                          'label': object.name, 'value': object.id
                        }
                      })}
                      value={selectedVisaAssignBy}
                      onChange={(value: any) => {
                        if (value) {
                          setSelectedVisaAssignBy(Array.prototype.map.call(value, function (v) { return v.value; }));
                        }

                      }}
                      isMulti={visadashboard?.data?.visaassignby.map((object: any, index: any) => {
                        return {
                          'label': object.name, 'value': object.id
                        }
                      })}
                      isLoading={visadashboardLoading}
                      placeholder={"Select VisaAssign By"}
                    />
                  </div>
                </div>
              )
            }

            {
              visadashboard?.data?.['visacountry'] && (
                <div className='col'>
                  <div className='mb-3'>
                    <CustomSelect
                      className={'form-select-solid fw-bold'}
                      options={visadashboard?.data?.visacountry.map((object: any, index: any) => {
                        return {
                          'label': object.name, 'value': object.id
                        }
                      })}
                      value={selectedCountry}
                      onChange={(value: any) => {
                        if (value) {
                          setSelectedCountry(Array.prototype.map.call(value, function (v) { return v.value; }));
                        }

                      }}
                      isMulti={visadashboard?.data?.visacountry.map((object: any, index: any) => {
                        return {
                          'label': object.name, 'value': object.id
                        }
                      })}
                      isLoading={visadashboardLoading}
                      placeholder={"Select Countries"}
                    />
                  </div>
                </div>
              )
            }

            {
              visadashboard?.data?.['vendor_detail'] && (
                <div className='col'>
                  <div className='mb-3'>
                    <CustomSelect
                      className={'form-select-solid fw-bold'}
                      options={visadashboard?.data?.vendor_detail.map((object: any, index: any) => {
                        return {
                          'label': object.name, 'value': object.id
                        }
                      })}
                      value={selectedVendor}
                      onChange={(value: any) => {
                        if (value) {
                          setSelectedVendor(Array.prototype.map.call(value, function (v) { return v.value; }));
                        }

                      }}
                      isMulti={visadashboard?.data?.vendor_detail.map((object: any, index: any) => {
                        return {
                          'label': object.name, 'value': object.id
                        }
                      })}
                      isLoading={visadashboardLoading}
                      placeholder={"Select Vendor"}
                    />
                  </div>
                </div>
              )
            }
            {/* <div className='col'>
            <div className='mb-3'>
              <Select
                className=' form-select-solid fw-bold'
                options={
                  dashboardinquiry?.data?.inquiryproducts.map((object: any, index: any) => (
                    {
                      value: object.id,
                      label: `${object.name}`
                    }
                  ))
                }
                isClearable
                styles={{
                  control: (base) => ({
                    ...base,
                    background: '#f5f8fa',
                    border: 'none',
                    borderRadius: '7px'
                  }),
                }}

                placeholder="Select Direct / Indirect"
              />
            </div>
          </div> */}

            <div className='col'>
              <div className='mb-3'>
                <CustomSelect
                  className={'form-select-solid fw-bold'}
                  options={followupOption}
                  value={selectedFollowup}
                  onChange={(value: any) => {
                    if (value) {
                      setSelectedFollowup(value.value);
                    } else {
                      setSelectedFollowup([]);
                    }
                  }}
                  isclearable={true}
                  // isMulti={followupOption}
                  // isMulti={false}
                  // isLoading={usersLoading}

                  placeholder={"Select Followup"}
                />

              </div>
            </div>

            {/* <div className='col'>
              <div className='mb-3'>
                <CustomSelect
                  className={'form-select-solid fw-bold'}
                  options={MouOption}
                  value={selectedMou}
                  onChange={(value: any) => {
                    if (value) {
                      setSelectedMou(value.value);
                      setSelectedProducts([]);
                    } else {
                      setSelectedMou([]);
                      setSelectedProducts([]);
                      setSelectedMouProducts([]);
                    }
                  }}
                  isclearable={true}
                  placeholder={"Select MOU"}
                />

              </div>
            </div> */}

            {
              visadashboard?.data && (
                <div className='col '>
                  <button
                    type='submit'
                    className='btn btn-primary fw-semibold px-6 me-2'
                    data-kt-menu-dismiss='true'
                    data-kt-table-filter='filter'
                    onClick={handleFormSubmit}
                  >
                    SUBMIT
                  </button>
                  <button
                    type='reset'
                    className='btn btn-warning text-gray-800 fw-semibold px-6'
                    data-kt-menu-dismiss='false'
                    data-kt-table-filter='filter'
                    onClick={handleFormReset}
                  >
                    Reset
                  </button>
                </div>
              )
            }


          </div>


          {/* <button
              type='button'
              className='btn btn-light btn-active-light-primary fw-semibold me-2 px-6'
              data-kt-menu-dismiss='true'
              data-kt-table-filter='reset'
            >
              Reset
            </button> */}



          {/* <a
          href='#'
          className='btn btn-primary fw-semibold'
          data-bs-toggle='modal'
          data-bs-target='#kt_modal_create_campaign'
        >
          Start Now
        </a> */}
        </div>
      </div>
    )
  )
}

export { VisaFilterForm }
